module.exports = __webpack_public_path__ + "static/media/delete-process.e894575a.svg";